import { memo, type ReactNode } from 'react';

import { TooltipContent, TooltipRoot, TooltipTrigger } from '@air/primitive-tooltip';

export type PrivateWorkspaceAgentPanelMessageSkillMonikerTooltipProps = {
  children: ReactNode;
  description: string;
  name: string;
};

/** Hover card for `/slashCommand` monikers — Radix composition (not primitive `Tooltip` overrides). */
export const PrivateWorkspaceAgentPanelMessageSkillMonikerTooltip = memo(
  ({ children, description, name }: PrivateWorkspaceAgentPanelMessageSkillMonikerTooltipProps) => (
    <TooltipRoot delayDuration={200}>
      <TooltipTrigger asChild>{children}</TooltipTrigger>
      <TooltipContent
        className="max-w-[280px] rounded-8 ads:border-ads-gray-5 ads:bg-raised bg-surface-1 p-4 font-normal ads:text-primary text-12 text-gray-12 shadow-popover dark:border dark:border-gray-5"
        data-testid="WORKSPACE_AGENT_MESSAGE_SKILL_MONIKER_TOOLTIP"
        hideArrow
        side="top"
        sideOffset={8}
      >
        <p
          className="mb-1 font-semibold ads:text-primary text-12 text-gray-12"
          data-testid="WORKSPACE_AGENT_MESSAGE_SKILL_MONIKER_TOOLTIP_NAME"
        >
          {name}
        </p>
        {description ? (
          <p
            className="font-normal ads:text-metadata text-12 text-gray-10"
            data-testid="WORKSPACE_AGENT_MESSAGE_SKILL_MONIKER_TOOLTIP_DESCRIPTION"
          >
            {description}
          </p>
        ) : null}
      </TooltipContent>
    </TooltipRoot>
  ),
);

PrivateWorkspaceAgentPanelMessageSkillMonikerTooltip.displayName =
  'PrivateWorkspaceAgentPanelMessageSkillMonikerTooltip';
